exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "ordenes-detalle .panel-trabajo-especialistas .table>tbody>tr>td{line-height:2.8;font-size:1.3em}ordenes-detalle .panel-trabajo-especialistas .table>tfoot{display:none}ordenes-detalle .panel-trabajo-especialistas table.dataTable thead td,ordenes-detalle .panel-trabajo-especialistas table.dataTable thead th{border-bottom:none}ordenes-detalle .panel-trabajo-especialistas .table>tbody>tr>th,ordenes-detalle .panel-trabajo-especialistas .table>tfoot>tr>th,ordenes-detalle .panel-trabajo-especialistas .table>thead>tr>th{background-color:#fff}ordenes-detalle .panel-trabajo-especialistas .widget,ordenes-detalle .panel-trabajo-especialistas .widget-body{background-color:#fff;padding:0;border:none}.modal-body .table.table-large>tbody>tr>td{line-height:2.8;font-size:1.1em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/ordenes/detalles/ordenes-detalle.scss
// module id = 1615
// module chunks = 0